import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/styles/form-styles.css';
import './assets/styles/table-styles.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import UserLayout from './layouts/UserLayout';
import { Provider } from 'react-redux';
import store from './redux/store';
import AuthLayout from './layouts/AuthLayout';
import RedirectRoute from './routes/RedirectRoute';
import './i18n';
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastContainer />
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route
            path='/auth/*'
            element={
              <RedirectRoute
                roleRedirects={{
                  customer: ""
                }}
              >
                <AuthLayout />
              </RedirectRoute>
            } />
          <Route
            path='/*'
            element={
              <UserLayout />
            } />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();